import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
// PWA ve Çevrimdışı çalışma motoru
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// DİKKAT: Buradaki 'unregister' kelimesini 'register' olarak değiştirdik!
// Bu sayede uygulama telefonlara yüklenebilecek ve internetsiz anlarda önbellekten çalışacak.
serviceWorkerRegistration.register();